import { Machine, assign } from 'xstate'

/* eslint-disable no-console */
export const editorMachine = Machine({
  id: 'editor',
  initial: 'idle',
  context: {
    // The item we want to edit
    item: {
      id: '',
      title: '',
      content: ''
    },
    feedback: '',
    toggleClass: ''
  },
  states: {
    idle: {
      // entry: { actions: ['assignOpenEditor'] },
      on: {
        DELETE: {
          target: 'delete',
          actions: ['assignCloseEditor', 'assignClearInputFields']
        },
        EDIT: {
          target: 'editContent',
          actions: ['setItemsToEdit']
        },
        EDIT_TITLE: {
          target: 'editTitle',
          actions: ['setItemsToEdit']
        },
        TOGGLE_EDITOR: {
          target: 'createNewContent',
          actions: ['assignOpenEditor']
        },
        TOGGLE_EDITOR_MIN: {
          target: 'createNewTitle',
          actions: ['assignOpenEditor']
        }
      }
    },
    // setup: minimal
    createNewTitle: {
      on: {
        ENTER_TITLE: {
          actions: ['assignTitle']
        },
        //
        SAVE: {
          actions: ['assignAddItem']
        },
        CANCEL: {
          target: 'idle'
        },
        //
        IDLE: {
          target: 'idle',
          actions: ['assignCloseEditor', 'assignClearInputFields']
        },
        EDIT: {
          target: 'editTitle',
          actions: ['assignOpenEditor', 'setItemsToEdit']
        },
        DELETE: {
          target: 'delete',
          actions: ['assignCloseEditor', 'assignClearInputFields']
        },
        TOGGLE_EDITOR_MIN: {
          target: 'idle',
          /// would be better to call this in "entry" of "idle" state,
          /// but that does not work
          actions: ['assignCloseEditor', 'assignClearInputFields']
        }
      }
    },
    editTitle: {
      on: {
        // React to changes in the input fields
        ENTER_TITLE: {
          actions: ['assignTitle']
        },
        // save or cancel
        UPDATE: {
          actions: ['assignUpdateItem']
        },
        CANCEL: {
          target: 'idle',
          actions: ['assignClearInputFields']
        },
        // 'IDLE' is called after "[Editor.]additem" was successful
        IDLE: {
          target: 'idle',
          actions: ['assignCloseEditor', 'assignClearInputFields']
        },
        EDIT: {
          target: 'editTitle',
          actions: ['assignOpenEditor', 'setItemsToEdit']
        },
        DELETE: {
          target: 'delete',
          actions: ['assignCloseEditor', 'assignClearInputFields']
        },
        // If user clicks on header of editor to close it
        TOGGLE_EDITOR: {
          target: 'idle',
          actions: ['assignCloseEditor', 'assignClearInputFields']
        },
        TOGGLE_EDITOR_MIN: {
          target: 'idle',
          /// would be better to call this in "entry" of "idle" state,
          /// but that does not work
          actions: ['assignCloseEditor', 'assignClearInputFields']
        }
      }
    },
    // setup: full
    createNewContent: {
      on: {
        ENTER_TITLE: {
          actions: ['assignTitle']
        },
        ENTER_CONTENT: {
          actions: ['assignContent']
        },
        //
        SAVE: {
          actions: ['assignAddItem']
        },
        CANCEL: {
          target: 'idle'
        },
        IDLE: {
          target: 'idle',
          actions: ['assignCloseEditor', 'assignClearInputFields']
        },
        EDIT: {
          target: 'editContent',
          actions: ['assignOpenEditor', 'setItemsToEdit']
        },
        DELETE: {
          target: 'delete',
          actions: ['assignCloseEditor', 'assignClearInputFields']
        },
        TOGGLE_EDITOR: {
          target: 'idle',
          /// would be better to call this in "entry" of "idle" state,
          /// but that does not work
          actions: ['assignCloseEditor', 'assignClearInputFields']
        }
      }
    },
    editContent: {
      // entry: { actions: ['assignOpenEditor'] },
      on: {
        // React to changes in the input fields
        ENTER_TITLE: {
          actions: ['assignTitle']
        },
        ENTER_CONTENT: {
          actions: ['assignContent']
        },
        // save or cancel
        UPDATE: {
          actions: ['assignUpdateItem']
        },
        CANCEL: {
          target: 'idle',
          actions: ['assignClearInputFields']
        },
        // 'IDLE' is called after "[Editor.]additem" was successful
        IDLE: {
          target: 'idle',
          actions: ['assignCloseEditor', 'assignClearInputFields']
        },
        EDIT: {
          target: 'editContent',
          actions: ['assignOpenEditor', 'setItemsToEdit']
        },
        DELETE: {
          target: 'delete',
          actions: ['assignCloseEditor', 'assignClearInputFields']
        },
        // ... don't know, how "NEW" could be called in this state...
        // NEW: {
        //   target: 'createNewContent'
        //   // actions: ['assignClearInputFields']
        // },
        // If user clicks on header of editor to close it
        TOGGLE_EDITOR: {
          target: 'idle',
          actions: ['assignCloseEditor', 'assignClearInputFields']
        },
        TOGGLE_EDITOR_MIN: {
          target: 'idle',
          actions: ['assignCloseEditor', 'assignClearInputFields']
        }
      }
    },
    delete: {
      on: {
        DELETE: {
          target: 'idle',
          actions: ['assignCloseEditor', 'assignClearInputFields']
        },
        EDIT: {
          target: 'editContent',
          actions: ['assignOpenEditor', 'setItemsToEdit']
        },
        EDIT_TITLE: {
          target: 'editTitle',
          actions: ['setItemsToEdit']
        },
        IDLE: {
          target: 'idle',
          actions: ['assignCloseEditor', 'assignClearInputFields']
        }
      }
    }
  }
}, {
  actions: {
    // TODO: Check where the values are coming from
    setItemsToEdit: assign({
      item: (context, event) => {
        console.log('')
        console.log('editorMachine: actions - setItemsToEdit: event.value =', event.value)
        context.item = event.value
        console.dir(context.item)
        return context.item
      }
    }),
    assignClearInputFields: assign({
      item: (context, event) => {
        context.item.id = ''
        context.item.title = ''
        context.item.content = ''
        // reach out to the editor and call a clear script there, too?
        // currently it is done in a separate function call on the parent
        // component (this.$emit('onResetEditor') ==> resetMode)
        return context.item
      }
    }),
    assignTitle: assign({
      item: (context, event) => {
        const obj = context.item
        obj.title = event.value
        return obj
      }
    }),
    assignContent: assign({
      item: (context, event) => {
        const obj = context.item
        obj.content = event.value
        return obj
      }
    })
    /// Defined in "withConfig" (in Editor.vue=> data => editorService), when
    /// interpret is assigned to editorService
    /// @TODO: these functions do not work in "entry" or "exit" actions!!
    // assignOpenEditor
    // assignCloseEditor
    // assignAddItem
    // assignUpdateItem
    // assignSetFeedback
  }
})
